import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionAddressNudgeTooltip = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { addressNudgeContext, nudgeText, cartIDs }: { addressNudgeContext: string; nudgeText: string; cartIDs: string },
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_ADDRESS_DISTANCE_TOOLTIP,
        label: nudgeText,
        context: addressNudgeContext,
        extraParams: cartIDs,
    });
};

export const impressionCheckoutLatLng = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    { addressNudgeContext, cartIDs }: { addressNudgeContext: string; cartIDs: string },
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CHECKOUT_LAT_LNG,
        context: addressNudgeContext,
        extraParams: cartIDs,
    });
};

export const clickCartAddressNudgeToolTipClose = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    { addressNudgeContext, nudgeText, cartIDs }: { addressNudgeContext: string; nudgeText: string; cartIDs: string },
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_ADDRESS_DISTANCE_NUDGE_CLOSE_BUTTON,
        label: nudgeText,
        context: addressNudgeContext,
        extraParams: cartIDs,
    });
};

export const impressionBottomAddressList = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    {
        addressesAndNudgeContext,
        nudgeText,
        cartIDs,
    }: { addressesAndNudgeContext: string; nudgeText: string; cartIDs: string },
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_ADDRESS_CHANGE,
        label: nudgeText,
        context: addressesAndNudgeContext,
        extraParams: cartIDs,
    });
};

export const clickReloadAddresses = (clickEvent: AnalyticsContextValue["clickEvent"], cartIDs: string): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_RELOAD_ADDRESSES,
        extraParams: cartIDs,
    });
};

export const clickAddOrSelectAddress = (clickEvent: AnalyticsContextValue["clickEvent"], cartIDs: string): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_ADD_OR_SELECT_ADDRESS,
        extraParams: cartIDs,
    });
};

export const impressionAddOrSelectAddress = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartIDs: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_ADD_OR_SELECT_ADDRESS,
        extraParams: cartIDs,
    });
};

export const impressionBottomAddressListError = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartIDs: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_ADDRESS_LIST_ERROR,
        extraParams: cartIDs,
    });
};
